import React from "react";
import { partners, program } from "../../data/program";
import { schedule } from "../../data/schedule";
import { programImage } from "../../data/site";
import { currentProgramDay, formatDay, PROGRAM_DAYS } from "../../utils/dates";
import { SectionHeading } from "./SectionHeading";
const blocks: Record<string, {
  label: string;
  col: string;
}> = {
  AM: {
    label: "Morning",
    col: "sm:col-start-1"
  },
  Lunch: {
    label: "Lunch · 12:00–13:30",
    col: "sm:col-start-2"
  },
  PM: {
    label: "Afternoon / evening",
    col: "sm:col-start-3"
  }
};
export function ProgramSection() {
  const today = currentProgramDay();
  return <section id="program" className="scroll-mt-20 bg-sun pt-24 md:pt-32" data-id="element-597" data-mp="2yn1tt7y4o86g">
      <div className="mx-auto max-w-[1400px] px-5 pb-24 md:px-8 md:pb-32" data-id="element-598" data-mp="33mn0y5ngbmu9">
        <SectionHeading title="Program partners" intro={program.summary} data-id="element-599" data-mp="1n8wks0j25849" />

        <div className="mt-16 grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center" data-id="element-600" data-mp="1n7lk49kwsghd">
          <img src={programImage} alt="Circuit boards, wiring and a 3D-printed prototype on a workbench" className="aspect-[4/3] w-full rounded-[28px] object-cover" data-id="element-601" data-mp="1s9kjz9hfwv9k" />
          <ul className="divide-y divide-ink/20 border-y border-ink/20" data-id="element-602" data-mp="273l53fyhlxmc">
            {partners.map(p => <li key={p.name} className="py-5" data-id="element-603" data-mp="2kz59z7hdsfar">
                <p className="text-[12px] font-bold uppercase tracking-wide text-ink/60" data-id="element-604" data-mp="2g1di2dgqkt6k">{p.role}</p>
                <p className="font-display text-4xl uppercase leading-tight" data-id="element-605" data-mp="2uynt5lpgvx1r">{p.name}</p>
                <p className="mt-1 text-[15px] text-ink/75" data-id="element-606" data-mp="2q1e4i89wjpez">{p.description}</p>
              </li>)}
          </ul>
        </div>
      </div>

      {/* Schedule sits on its own cream band (same as Teams) so it reads as a separate block from the partners. */}
      <div className="bg-cream py-24 text-ink md:py-32" data-id="element-607" data-mp="3dq6u7mzxl115">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-608" data-mp="3dqyngr622mo9">
        <h3 className="font-display text-5xl uppercase md:text-6xl" data-id="element-609" data-mp="38rm4wim7w1rh">Schedule</h3>
        <p className="mt-2 text-[13px] font-semibold uppercase tracking-wide text-ink/80" data-id="element-610" data-mp="26do9ydkpf50h">
          October 7 – 13, 2026 · Times in Pacific · Daily videos due 21:00
        </p>

        <ol className="mt-8 border-t-2 border-ink" data-id="element-611" data-mp="2ad6tp60sha1q">
          {schedule.map(d => {
            const isToday = d.day === today;
            const isDemo = d.day === PROGRAM_DAYS + 1;
            return <li key={d.day} className={`grid gap-5 border-b border-ink/30 py-8 lg:grid-cols-[180px_minmax(0,260px)_1fr] lg:gap-8 ${isDemo ? "bg-ink -mx-5 px-5 text-sun md:-mx-8 md:px-8" : ""}`} data-id="element-612" data-mp="2k6xgm6h9pcfb">
                <div data-id="element-613" data-mp="2y5n918t56nxc">
                  <p className="font-display text-5xl uppercase leading-none" data-id="element-614" data-mp="333yl7q6wtaiq">{formatDay(d.day, "MMM dd")}</p>
                  <p className="mt-1 flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide" data-id="element-615" data-mp="13r2u7cri5mlv">
                    {isDemo ? "Demo Day" : `Day ${String(d.day).padStart(2, "0")}`}
                    {isToday && <span className="rounded-full bg-ink px-2 py-0.5 text-sun" data-id="element-616" data-mp="1164yk5cewikb">Today</span>}
                  </p>
                </div>
                <div data-id="element-617" data-mp="wewmt2nm0l3z">
                  <p className="font-display text-3xl uppercase leading-tight" data-id="element-618" data-mp="wedbi4sgsuyx">{d.theme}</p>
                  <p className={`mt-3 text-[11px] font-bold uppercase tracking-wide ${isDemo ? "text-sun/70" : "text-ink/80"}`} data-id="element-619" data-mp="rgv3cgm9ujrz">
                    Goal for the day
                  </p>
                  <p className={`mt-0.5 text-[16px] font-semibold leading-snug ${isDemo ? "text-cream" : ""}`} data-id="element-620" data-mp="1k4qwxcgjnvkj">{d.goal}</p>
                </div>
                <dl className="grid gap-x-8 gap-y-4 sm:grid-cols-[1fr_0.7fr_1.3fr]" data-id="element-621" data-mp="1a72zgerk09yo">
                  {d.sessions.map(s =>
                // Each block keeps its own column, so a day without lunch stays aligned.
                <div key={s.time + s.title} className={blocks[s.time]?.col ?? ""} data-id="element-622" data-mp="3uxkc899bu5kt">
                      <dt className={`text-[11px] font-bold uppercase tracking-wide ${isDemo ? "text-sun/70" : "text-ink/80"}`} data-id="element-623" data-mp="3qv76vlyhs9ok">
                        {blocks[s.time]?.label ?? s.time}
                      </dt>
                      <dd className={`mt-1 text-[15px] leading-snug ${isDemo ? "text-cream" : ""}`} data-id="element-624" data-mp="1ne0k8jijbcq1">{s.title}</dd>
                    </div>)}
                </dl>
              </li>;
          })}
        </ol>
      </div>
      </div>
    </section>;
}